const wildape = {
    themeName: 'wildape',
    brand: 'Wild Ape',
    font: {
        main: ['Geist', 'sans-serif'],
        alternative: ['Clash Display', 'sans-serif'],
        'alternative-2': ['Geist', 'sans-serif'],
        'alternative-3': ['Geist', 'sans-serif']
    },
    color: {
        primary: {
            '100': '#DCFF4A',
            '300': '#DCFF4A',
            '500': '#D8FF36',
            '700': '#C2E631',
            '900': '#C2E631'
        },
        secondary: {
            '100': '#30313D',
            '300': '#22232D',
            '500': '#1A1B23',
            '700': '#1A1B23',
            '900': '#1A1B23'
        },
        tertiary: {
            '100': '#30313D',
            '300': '#22232D',
            '500': '#1A1B23',
            '700': '#1A1B23',
            '900': '#1A1B23'
        },
        accent: {
            '100': '#DCFF4A',
            '300': '#DCFF4A',
            '500': '#D8FF36',
            '700': '#C2E631',
            '900': '#C2E631'
        },
        neutral: {
            '100': '#8a8c9c',
            '300': '#717280',
            '500': '#5b5c69',
            '700': '#454650',
            '900': '#30313D'
        },
        background: {
            '100': '#22232D',
            '300': '#22232D',
            '500': '#1A1B23',
            '700': '#121319',
            '900': '#090A0D'
        },
        success: {
            '100': '#62EEAA',
            '300': '#06F290',
            '500': '#04E275',
            '700': '#04CC6C',
            '900': '#039F54'
        },
        warning: {
            '100': '#FFFA41',
            '300': '#FFEC0E',
            '500': '#EBCD01',
            '700': '#EBCD01',
            '900': '#A67602'
        },
        error: {
            '100': '#FFAF72',
            '300': '#FE8339',
            '500': '#FD6012',
            '700': '#E74308',
            '900': '#C53109'
        },
        info: {
            '100': '#BDE9FF',
            '300': '#7AD3FF',
            '500': '#58C7FE',
            '700': '#47A0CC',
            '900': '#367899'
        },
        text: {
            '100': '#FFFFFF',
            '300': '#FFFFFFCC',
            '500': '#FFFFFF99',
            '700': '#FFFFFF66',
            '900': '#090A0D'
        },
        highlight: { '1': '#D8FF36', '2': '#6945E8', '3': '#D8FF36', '4': '#2E1D62', '5': '#2E1D62' }
    },
    gradients: {
        main: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.tertiary.500', at: '0%' },
                { token: 'color.background.100', at: '100%' }
            ]
        },
        alternative: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.300', at: '100%' }
            ]
        },
        'alternative-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.700', at: '100%' }
            ]
        },
        'alternative-3': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.700', at: '0%' },
                { token: 'color.background.100', at: '100%' }
            ]
        },
        'alternative-4': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-5': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.300', at: '0%' },
                { token: 'color.background.900', at: '100%' }
            ]
        },
        'alternative-6': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.background.100', at: '0%' },
                { token: 'color.background.700', at: '100%' }
            ]
        },
        primary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.100', at: '0%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        'primary-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.100', at: '0%' },
                { token: 'color.primary.500', at: '100%' }
            ]
        },
        'primary-dark': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.primary.500', at: '0%' },
                { token: 'color.primary.900', at: '100%' }
            ]
        },
        secondary: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.500', at: '0%' },
                { token: 'color.secondary.700', at: '100%' }
            ]
        },
        'secondary-light': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.secondary.300', at: '0%' },
                { token: 'color.secondary.500', at: '100%' }
            ]
        },
        accent: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.accent.300', at: '0%' },
                { token: 'color.accent.500', at: '100%' }
            ]
        },
        success: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.success.500', at: '0%' },
                { token: 'color.success.900', at: '100%' }
            ]
        },
        error: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.500', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        'error-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'color.error.300', at: '0%' },
                { token: 'color.error.700', at: '100%' }
            ]
        },
        christmas: {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.2', at: '0%' },
                { token: 'christmas.1', at: '100%' }
            ]
        },
        'christmas-2': {
            type: 'linear',
            angle: '180deg',
            stops: [
                { token: 'christmas.3', at: '0%' },
                { token: 'christmas.4', at: '100%' }
            ]
        }
    },
    borderRadius: {
        button: { default: '12px', small: '8px' },
        input: { default: '16px', message: '8px' },
        header: { chatNotifications: '12px', profile: '12px', toggle: '12px', vip: '12px' },
        promotions: { item: '8px' }
    },
    components: {
        error: { background: 'color.error.500', text: 'color.text.100' },
        footer: { social: 'color.neutral.900' },
        info: { background: 'color.info.500', text: 'color.text.100' },
        input: {
            background: 'color.background.300',
            border: 'color.neutral.900',
            'border-hover': 'color.secondary.500',
            'border-active': 'color.primary.500'
        },
        progress: {
            background: 'color.background.900',
            'background-2': 'color.background.900',
            fill: 'color.primary.500',
            'fill-2': 'color.highlight.2',
            'fill-2-shadow': 'color.highlight.2',
            'fill-shadow': 'color.primary.500'
        },
        success: { background: 'color.success.500', text: 'color.text.100' },
        table: { 'odd-row': 'color.background.500' },
        warning: { background: 'color.warning.500', text: 'color.text.900' }
    },
    boxShadows: {
        neutral: '0px -5px 6px 0px #00000040 inset, 0px 5px 6px 0px #ffffff40 inset',
        inner: 'none',
        vip: '0px 0px 8px 0px #ffffff7a'
    },
    maxHeight: { zero: '0', full: '100%' },
    transitions: { maxHeight: 'max-height', rotate: 'transform' },
    rotate: { '360': '360deg' },
    width: { fitContent: 'fit-content', width15: '3.70rem', chatWidth: '340px' },
    height: { height15: '3.70rem' },
    screens: { xs390: '390px', customSm: '580px', custom720: '720px' },
    christmas: {
        '1': '#B00404',
        '2': '#FD5757',
        '3': '#FED234',
        '4': '#FF952B',
        '5': '#61370D',
        '6': '#FF9E14',
        '7': '#1C3899'
    },
    vip: { '1': 'color.highlight.3', '2': 'color.highlight.3' }
};
export default wildape;
